import React, { FC } from 'react'
import { Divider } from 'antd'
import { WithdrawalEdit } from '../../edit'
import { FormDataFields } from '../FormDataFields/component'
import { mappingBankValue } from '../../../utils'

type TransactionDetailsProps = {
  withdrawal: WithdrawalEdit
  displayMode?: 'divider' | 'collapse' | 'card'
  fieldFormatters?: Record<
    string,
    (value: any, key: string, context?: any) => React.ReactNode
  >
  hideExtra?: boolean
}

// shared row styles — match page.tsx infoRow tokens
const rowStyle: React.CSSProperties = {
  display: 'flex',
  gap: 12,
  alignItems: 'baseline',
  padding: '5px 0',
  borderBottom: '1px solid var(--crm-border)',
}

const labelStyle: React.CSSProperties = {
  fontSize: 14,
  color: 'var(--crm-text-secondary)',
  flexShrink: 0,
}

const valueStyle: React.CSSProperties = {
  fontSize: 16,
  fontWeight: 600,
  fontFamily: 'monospace',
  textAlign: 'left',
  wordBreak: 'break-all',
}

// human-readable label from camelCase / snake_case key
function formatKey(key: string): string {
  return key
    .replace(/([A-Z])/g, ' $1')
    .replace(/_/g, ' ')
    .replace(/^\w/, (c) => c.toUpperCase())
    .trim()
}

export const TransactionDetails: FC<TransactionDetailsProps> = ({
  withdrawal,
  displayMode = 'collapse',
  fieldFormatters = {},
  hideExtra = false,
}) => {
  const hasSequenceFields = withdrawal.formDataFieldSequenceOrder?.length > 0

  if (hasSequenceFields) {
    return (
      <FormDataFields
        fields={withdrawal.formDataFieldSequenceOrder}
        displayMode={displayMode}
        fieldFormatters={fieldFormatters}
        context={withdrawal}
        hideExtra={hideExtra}
      />
    )
  }

  return (
    <>
      {/* korapay extra data */}
      {withdrawal.externalPaymentTransaction?.extraData &&
        withdrawal.processingProvider === 'korapay' && (
          <>
            <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--crm-text-secondary)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 8 }}>
              Transaction Details
            </div>
            {Object.entries(
              JSON.parse(withdrawal.externalPaymentTransaction.extraData),
            ).map(([key, value]) => (
              <div key={key} style={rowStyle}>
                <span style={labelStyle}>{formatKey(key)}</span>
                <span style={valueStyle}>{String(value)}</span>
              </div>
            ))}
            <Divider style={{ margin: '12px 0' }} />
          </>
        )}

      {/* formData fields */}
      {withdrawal.formData &&
        Object.entries(withdrawal.formData).map(([key, value]) => (
          <div key={key} style={rowStyle}>
            <span style={labelStyle}>{formatKey(key)}</span>
            <span style={valueStyle}>
              {mappingBankValue(key, String(value), withdrawal)}
            </span>
          </div>
        ))}
    </>
  )
}
